import axiosInstance from "auth/FetchInterceptor";
import { MY_PERMISSION_API, SWITCH_WORKSPACE } from "constants/ApiConstant";

const WorkspaceService = {};

WorkspaceService.getMyPermission = function () {
  return axiosInstance.get(MY_PERMISSION_API, null);
};

WorkspaceService.switchWorkspace = function (workspace) {
  return axiosInstance.put(`${SWITCH_WORKSPACE}/${workspace}`, null);
};

export default WorkspaceService;
